import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'


const Team = [
    {
       Id:'1',
       tImg:timg1,
       name:'Henry Barton',
       title:'Team Leader',     
    },
    {
       Id:'2',
       tImg:timg2,
       name:'Mattie Washington',
       title:'Junior Member',     
    },
    {
       Id:'3',
       tImg:timg3,
       name:'Winifred Harmon',
       title:'Team Leader',     
    },
    {
       Id:'4',
       tImg:timg4,
       name:'Shelia Lawrence',
       title:'Senior Member',     
    }
    
]

export default Team;